import React from "react";

const Loading = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "75vh" }}
    >
      <div
        className="spinner-border spin"
        role="status"
        style={{ width: "50px", height: "50px" }}
      ></div>
    </div>
  );
};

export default Loading;
